/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentRecordFileInfoDto } from './incidentRecordFileInfoDto.schema';

export const IEnumerableOfIncidentRecordFileInfoDto = zod.array(zod.lazy(() => IncidentRecordFileInfoDto));

export type IEnumerableOfIncidentRecordFileInfoDto = zod.input<typeof IEnumerableOfIncidentRecordFileInfoDto>;
export type IEnumerableOfIncidentRecordFileInfoDtoOutput = zod.output<typeof IEnumerableOfIncidentRecordFileInfoDto>;
